var t = "//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js",
  e = {
    rootClass: {
      type: String,
      default: "adswrapper"
    },
    insClass: {
      type: String,
      default: ""
    },
    insStyle: {
      type: String,
      default: "display:block;"
    },
    dataAdClient: {
      type: String,
      default: ""
    },
    dataAdSlot: {
      type: String,
      default: ""
    },
    dataAdLayoutKey: {
      type: String,
      default: "-fg+5n+6t-e7+r"
    },
    dataAdTest: {
      type: String,
      default: ""
    },
    dataAdFormat: {
      type: String,
      default: "auto"
    },
    isNonPersonalizedAds: {
      type: String,
      default: "no"
    },
    dataFullWidthResponsive: {
      type: String,
      default: "no"
    },
    dataAdRegion: {
      type: String,
      default: ""
    },
    isNewAdsCode: {
      type: String,
      default: "no"
    }
  };
var a = function (t, e, a, s, d, n, o, i, r, l) {
    "boolean" != typeof o && (r = i, i = o, o = !1);
    var c,
      p = "function" == typeof a ? a.options : a;
    if (t && t.render && (p.render = t.render, p.staticRenderFns = t.staticRenderFns, p._compiled = !0, d && (p.functional = !0)), s && (p._scopeId = s), n ? (c = function (t) {
      (t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), e && e.call(this, r(t)), t && t._registeredComponents && t._registeredComponents.add(n);
    }, p._ssrRegister = c) : e && (c = o ? function () {
      e.call(this, l(this.$root.$options.shadowRoot));
    } : function (t) {
      e.call(this, i(t));
    }), c) if (p.functional) {
      var y = p.render;
      p.render = function (t, e) {
        return c.call(e), y(t, e);
      };
    } else {
      var u = p.beforeCreate;
      p.beforeCreate = u ? [].concat(u, c) : [c];
    }
    return a;
  },
  s = a({
    render: function () {
      var t = this,
        e = t.$createElement,
        a = t._self._c || e;
      return a("div", {
        class: t.rootClass
      }, ["yes" === t.isNewAdsCode ? [a("script2", {
        attrs: {
          type: "text/javascript",
          async: "true",
          src: t.ADS_SCRIPT + "?client=" + t.dataAdClient,
          crossorigin: "anonymous"
        }
      })] : t._e(), t._v(" "), "no" === t.isNewAdsCode ? [a("script2", {
        attrs: {
          type: "text/javascript",
          async: "true",
          src: t.ADS_SCRIPT
        }
      })] : t._e(), t._v(" "), a("ins", {
        staticClass: "adsbygoogle",
        class: t.insClass,
        style: t.insStyle,
        attrs: {
          "data-ad-client": t.dataAdClient,
          "data-ad-slot": t.dataAdSlot,
          "data-ad-test": t.dataAdTest,
          "data-ad-format": t.dataAdFormat,
          "data-ad-region": t.dataAdRegion,
          "data-full-width-responsive": "yes" === t.dataFullWidthResponsive
        }
      }), t._v(" "), "yes" === t.isNonPersonalizedAds ? [a("script2", {
        attrs: {
          type: "text/javascript"
        }
      }, [t._v("\n      (adsbygoogle = window.adsbygoogle || []).requestNonPersonalizedAds = 1; (adsbygoogle = window.adsbygoogle || []).push({});\n    ")])] : t._e(), t._v(" "), "no" === t.isNonPersonalizedAds ? [a("script2", {
        attrs: {
          type: "text/javascript"
        }
      }, [t._v(" (adsbygoogle = window.adsbygoogle || []).push({}); ")])] : t._e()], 2);
    },
    staticRenderFns: []
  }, void 0, {
    name: "Adsense",
    props: e,
    data: function () {
      return {
        ADS_SCRIPT: t
      };
    }
  }, void 0, !1, void 0, void 0, void 0),
  d = {
    install: function (t) {
      t.component("Adsense", s);
    }
  },
  n = function (t, e) {
    var a = Object(t);
    for (var s in e) Object.prototype.hasOwnProperty.call(e, s) && (a[s] = e[s]);
    return a;
  },
  o = a({
    render: function () {
      var t = this,
        e = t.$createElement,
        a = t._self._c || e;
      return a("div", {
        class: t.rootClass
      }, ["yes" === t.isNewAdsCode ? [a("script2", {
        attrs: {
          type: "text/javascript",
          async: "true",
          src: t.ADS_SCRIPT + "?client=" + t.dataAdClient,
          crossorigin: "anonymous"
        }
      })] : t._e(), t._v(" "), "no" === t.isNewAdsCode ? [a("script2", {
        attrs: {
          type: "text/javascript",
          async: "true",
          src: t.ADS_SCRIPT
        }
      })] : t._e(), t._v(" "), a("ins", {
        staticClass: "adsbygoogle",
        class: t.insClass,
        style: t.insStyle,
        attrs: {
          "data-ad-layout": "in-article",
          "data-ad-format": t.dataAdFormat,
          "data-ad-client": t.dataAdClient,
          "data-ad-slot": t.dataAdSlot,
          "data-ad-test": t.dataAdTest,
          "data-ad-region": t.dataAdRegion,
          "data-full-width-responsive": "yes" === t.dataFullWidthResponsive
        }
      }), t._v(" "), "yes" === t.isNonPersonalizedAds ? [a("script2", {
        attrs: {
          type: "text/javascript"
        }
      }, [t._v("\n      (adsbygoogle = window.adsbygoogle || []).requestNonPersonalizedAds = 1; (adsbygoogle = window.adsbygoogle || []).push({});\n    ")])] : t._e(), t._v(" "), "no" === t.isNonPersonalizedAds ? [a("script2", {
        attrs: {
          type: "text/javascript"
        }
      }, [t._v(" (adsbygoogle = window.adsbygoogle || []).push({}); ")])] : t._e()], 2);
    },
    staticRenderFns: []
  }, void 0, {
    name: "InArticleAdsense",
    props: n(e, {
      dataAdFormat: {
        type: String,
        default: "fluid"
      }
    }),
    data: function () {
      return {
        ADS_SCRIPT: t
      };
    }
  }, void 0, !1, void 0, void 0, void 0),
  i = {
    install: function (t) {
      t.component("InArticleAdsense", o);
    }
  },
  r = a({
    render: function () {
      var t = this,
        e = t.$createElement,
        a = t._self._c || e;
      return a("div", {
        class: t.rootClass
      }, ["yes" === t.isNewAdsCode ? [a("script2", {
        attrs: {
          type: "text/javascript",
          async: "true",
          src: t.ADS_SCRIPT + "?client=" + t.dataAdClient,
          crossorigin: "anonymous"
        }
      })] : t._e(), t._v(" "), "no" === t.isNewAdsCode ? [a("script2", {
        attrs: {
          type: "text/javascript",
          async: "true",
          src: t.ADS_SCRIPT
        }
      })] : t._e(), t._v(" "), a("ins", {
        staticClass: "adsbygoogle",
        class: t.insClass,
        style: t.insStyle,
        attrs: {
          "data-ad-format": t.dataAdFormat,
          "data-ad-layout-key": t.dataAdLayoutKey,
          "data-ad-client": t.dataAdClient,
          "data-ad-slot": t.dataAdSlot,
          "data-ad-test": t.dataAdTest,
          "data-ad-region": t.dataAdRegion,
          "data-full-width-responsive": "yes" === t.dataFullWidthResponsive
        }
      }), t._v(" "), "yes" === t.isNonPersonalizedAds ? [a("script2", {
        attrs: {
          type: "text/javascript"
        }
      }, [t._v("\n      (adsbygoogle = window.adsbygoogle || []).requestNonPersonalizedAds = 1; (adsbygoogle = window.adsbygoogle || []).push({});\n    ")])] : t._e(), t._v(" "), "no" === t.isNonPersonalizedAds ? [a("script2", {
        attrs: {
          type: "text/javascript"
        }
      }, [t._v(" (adsbygoogle = window.adsbygoogle || []).push({}); ")])] : t._e()], 2);
    },
    staticRenderFns: []
  }, void 0, {
    name: "InFeedAdsense",
    props: n(e, {
      dataAdFormat: {
        type: String,
        default: "fluid"
      }
    }),
    data: function () {
      return {
        ADS_SCRIPT: t
      };
    }
  }, void 0, !1, void 0, void 0, void 0),
  l = {
    Adsense: d,
    InArticleAdsense: i,
    InFeedAdsense: {
      install: function (t) {
        t.component("InFeedAdsense", r);
      }
    },
    AutoAdsense: {
      install: function (e, a) {
        var s = a.adClient,
          d = void 0 === s ? "" : s,
          n = a.isNewAdsCode,
          o = void 0 !== n && n;
        if (!d) return Error('AutoAdsense require "adClient" parameter');
        var i = document.head,
          r = document.createElement("script");
        r.type = "text/javascript", r.async = !0, o ? (r.crossOrigin = "anonymous", r.src = t + "?client=" + d) : r.src = t, r.onload = function () {
          (adsbygoogle = window.adsbygoogle || []).push({
            google_ad_client: d,
            enable_page_level_ads: !0
          });
        }, i.appendChild(r);
      }
    }
  };
export default l;